import { NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Newspaper, Images, Users, Archive, ExternalLink, LogOut, Rss, Mail } from "lucide-react";

export function AdminLayout({ children, title }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const nav = [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
    { to: "/admin/artikel", label: "Artikel", icon: Newspaper },
    { to: "/admin/mediathek", label: "Mediathek", icon: Images },
  ];
  if (user?.role === "admin") nav.push({ to: "/admin/rss", label: "RSS-Import", icon: Rss });
  if (user?.role === "admin") nav.push({ to: "/admin/newsletter", label: "Newsletter", icon: Mail });
  if (user?.role === "admin") nav.push({ to: "/admin/benutzer", label: "Benutzer", icon: Users });

  const doLogout = () => { logout(); navigate("/admin/login"); };

  return (
    <div className="min-h-screen flex bg-offwhite notranslate">
      <aside data-testid="admin-sidebar" className="w-60 bg-prussian text-white flex flex-col fixed h-full">
        <div className="px-5 py-5 border-b border-white/10">
          <Link to="/admin" className="font-headline font-bold text-lg tracking-[0.06em]">KONTINENTZEIT</Link>
          <p className="text-[10px] uppercase tracking-widest text-white/50 mt-1 font-body">Redaktionssystem</p>
        </div>
        <nav className="flex-1 py-4">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-5 py-3 font-body text-sm transition-colors ${isActive ? "bg-white/10 text-gold border-l-2 border-gold" : "text-white/80 hover:bg-white/5 border-l-2 border-transparent"}`}>
              <n.icon size={17} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-white/10 py-3">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-5 py-2.5 text-white/70 hover:text-gold text-sm font-body">
            <ExternalLink size={16} /> Website ansehen
          </a>
        </div>
      </aside>

      <div className="flex-1 ml-60 flex flex-col min-h-screen">
        <header className="bg-white border-b border-edborder h-16 flex items-center justify-between px-8 sticky top-0 z-20">
          <h1 className="font-headline font-bold text-2xl text-prussian">{title}</h1>
          <div className="flex items-center gap-4">
            <div className="text-right">
              <p className="text-sm font-semibold text-prussian font-body leading-tight">{user?.name}</p>
              <p className="text-[11px] text-muted-foreground uppercase tracking-wide">{user?.role === "admin" ? "Administrator" : "Redakteur"}</p>
            </div>
            <button data-testid="admin-logout-btn" onClick={doLogout} title="Abmelden"
              className="w-9 h-9 flex items-center justify-center border border-edborder text-prussian hover:bg-offwhite">
              <LogOut size={16} />
            </button>
          </div>
        </header>
        <main data-testid="admin-portal" className="flex-1 p-8">{children}</main>
      </div>
    </div>
  );
}
